import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";
import {openUrlWithIpgCallbackChannelSubscribe, threeDigitsSep} from "../../helpers";
import {OrderContextValues} from "../../contexts/OrderContext";
import * as DocumentPicker from "expo-document-picker";
import * as Navigator from "../../refrences/RootNavigation";

interface state {
    receiptFile: File | undefined,
}

interface props {
    orderContext: OrderContextValues,
    children: any
}

export default class IPGCompletionComponents extends FunctionDefinedComponents <props, state> {

    constructor(props: any) {
        super(props);
        this.state = {
            receiptFile: undefined
        }
    }

    go() {
        this.props.orderContext.ipgLink().then((link: string) => {
            if (this.props.orderContext.order != null)
                openUrlWithIpgCallbackChannelSubscribe(link, this.props.orderContext.order?.id, () => {
                    Navigator.replace("Menu");
                }, ()=>{
                    Navigator.replace("Menu");
                });
        });
    }

    cancel() {
        this.props.orderContext.cancel();
    }

    rolledChildren(): RolledChildType {
        return [
            {
                role: "desc-text",
                visible: true,
                props: {},
                children: 'شما یک سفارش منتظر پرداخت دارید. جهت تکمیل پرداخت روی دکمه انتقال به درگاه پرداخت کلیک کنید.'
            },
            {
                role: "summary-text",
                visible: true,
                props: {},
                children: [
                    this.props.orderContext.order?.summary ?? ""
                ]
            },
            {
                role: "price-text",
                visible: true,
                props: {},
                children: `${threeDigitsSep(((this.props.orderContext.order?.totalPayablePrice ?? 0) + 
                        (this.props.orderContext.order?.ipgWage ?? 0)) * 10)} ریال`
            },
            {
                role: "button-go",
                visible: true,
                props: {
                    title: "انتقال به درگاه پرداخت",
                    onPress: () => {
                        this.go();
                    }
                },
                children: null,
            },
            {
                role: "button-cancel",
                visible: true,
                props: {
                    title: "از سفارش منصرف شدم",
                    onPress: () => {
                        this.cancel();
                    }
                },
                children: null,
            },
        ];
    }

}
